<template>
  <div class="app-main-content">
    <div class="details-view" style="overflow: auto">
      <div class="main-content" style="width: fit-content">
        <div style="display: flex">
          <!--基本信息-->
          <div class="section form-column">
            <el-form
              label-width="140px"
              label-position="right"
            >
              <span class="title">{{ $t('CargoMsg.Cargo_BasicInfo') }}</span>
              <!--直达/中转-->
              <el-form-item :label="$t('CargoMsg.Cargo_DirectOrTransshipment')" required>
                <cargo-advance-select
                  no="directTransit"
                  tag-value="code"
                  filterable
                  :clearable="false"
                  :default-value="filter.directTransit"
                  :static-options="SystemConstants.DIRECT_TRANSITS"
                  @parentCallBack="p=>{filter.directTransit=p.value; filter.transferPortCode=''}"
                />
              </el-form-item>
              <!--航线-->
              <el-form-item :label="$t('CargoMsg.Cargo_Airline')" required>
                <cargo-advance-select
                  :select-type="TYPE_NAMES.basic_data_Region"
                  filterable
                  :default-value="filter.commerceCode"
                  style="width:100%"
                  @parentCallBack="p=>{filter.commerceCode=p.value;}"
                />
              </el-form-item>
              <!--起运港-->
              <el-form-item
                v-if="type === SystemConstants.PRICE_INQUIRY_TYPE_SEA_FCL.code || type === SystemConstants.PRICE_INQUIRY_TYPE_SEA_LCL.code"
                :label="$t('CargoMsg.Cargo_POL')"
              >
                <cargo-advance-select
                  :select-type="TYPE_NAMES.basic_data_Seaport"
                  filterable
                  :default-value="filter.pol"
                  style="width:100%"
                  @parentCallBack="p=>filter.pol=p.value"
                />
              </el-form-item>
              <!--起始地-->
              <el-form-item
                v-if="type === SystemConstants.PRICE_INQUIRY_TYPE_AIR.code"
                :label="$t('Invoice.Origin')"
              >
                <cargo-advance-select
                  :select-type="TYPE_NAMES.basic_data_Airport"
                  filterable
                  :default-value="filter.pol"
                  style="width:100%"
                  @parentCallBack="p=>filter.pol=p.value"
                />
              </el-form-item>
              <!--卸货港-->
              <el-form-item
                v-if="type === SystemConstants.PRICE_INQUIRY_TYPE_SEA_FCL.code || type === SystemConstants.PRICE_INQUIRY_TYPE_SEA_LCL.code"
                :label="$t('CargoMsg.Cargo_PortOfDischarge')"
              >
                <cargo-advance-select
                  :select-type="TYPE_NAMES.basic_data_Seaport"
                  filterable
                  :default-value="filter.pod"
                  style="width:100%"
                  @parentCallBack="podChange"
                />
              </el-form-item>
              <!--目的地-->
              <el-form-item
                v-if="type === SystemConstants.PRICE_INQUIRY_TYPE_AIR.code"
                :label="$t('CargoMsg.Cargo_Destination')"
              >
                <cargo-advance-select
                  :select-type="TYPE_NAMES.basic_data_Airport"
                  filterable
                  :default-value="filter.pod"
                  style="width:100%"
                  @parentCallBack="podChange"
                />
              </el-form-item>
              <!--中转港-->
              <el-form-item
                v-if="filter.directTransit === SystemConstants.DIRECT_TRANSIT_TRANSIT.code"
                :label="$t('SeaExport.TransitPort')"
                required
              >
                <cargo-advance-select
                  :select-type="TYPE_NAMES.basic_data_Seaport"
                  filterable
                  :default-value="filter.transferPortCode"
                  style="width:100%"
                  @parentCallBack="p=>filter.transferPortCode=p.value"
                />
              </el-form-item>
              <!--船公司-->
              <el-form-item
                v-if="type === SystemConstants.PRICE_INQUIRY_TYPE_SEA_FCL.code || type === SystemConstants.PRICE_INQUIRY_TYPE_SEA_LCL.code"
                :label="$t('SeaExport.ShippingCompany')"
              >
                <cargo-advance-select
                  no="carrierId"
                  filterable
                  :select-type="TYPE_NAMES.basic_data_Company"
                  :method-params="{seaCmp:true,companyLob:'seaExport',active:true}"
                  :default-value="filter.carrierId || ''"
                  placeholder=" "
                  @parentCallBack="p => filter.carrierId=p.value"
                />
              </el-form-item>
              <!--航空公司-->
              <el-form-item
                v-if="type === SystemConstants.PRICE_INQUIRY_TYPE_AIR.code"
                :label="$t('CargoMsg.Cargo_AirlineCompany')"
              >
                <cargo-advance-select
                  no="carrierId"
                  filterable
                  :select-type="TYPE_NAMES.basic_data_Company"
                  :method-params="{airCmp:true,companyLob:'airExport',active:true}"
                  :default-value="filter.carrierId || ''"
                  placeholder=" "
                  @parentCallBack="p => filter.carrierId=p.value"
                />
              </el-form-item>
              <!--服务条款-->
              <el-form-item :label="$t('CargoMsg.Cargo_Terms')">
                <cargo-advance-select
                  no="serviceTerm"
                  filterable
                  :select-type="TYPE_NAMES.basic_data_IncoTerm"
                  callback-method-type="value"
                  :default-value="filter.serviceTerm"
                  :callback-params="{key:'incoTerm'}"
                  @parentCallBack="p => filter.serviceTerm = p.value"
                />
              </el-form-item>
            </el-form>
          </div>
          <div class="section form-column">
            <!--货物信息-->
            <el-form
              label-width="140px"
              label-position="right"
            >
              <!--货物信息-->
              <span class="title">{{ $t('CargoMsg.Cargo_CargoInfo') }}</span>
              <!--货物类型-->
              <el-form-item :label="$t('SeaExport.CargoType')">
                <el-radio-group v-model="type" disabled>
                  <el-radio :label="SystemConstants.PRICE_INQUIRY_TYPE_SEA_FCL.code" style="margin-right: 5px;">{{ $t('CargoMsg.Cargo_FCL') }}</el-radio>
                  <el-radio :label="SystemConstants.PRICE_INQUIRY_TYPE_SEA_LCL.code" style="margin-right: 5px;">{{ $t('Pricing.LCL') }}</el-radio>
                  <el-radio :label="SystemConstants.PRICE_INQUIRY_TYPE_AIR.code" style="margin-right: 5px;">{{ $t('CargoMsg.Cargo_Air') }}</el-radio>
                </el-radio-group>
              </el-form-item>
              <span v-if="type === SystemConstants.PRICE_INQUIRY_TYPE_SEA_FCL.code" class="title">{{ $t('CargoMsg.Cargo_CartonQuantity') }}
                <i style="color: #42b983; cursor: pointer; right: 35px; top: -4px; font-size: 18px" class="el-icon-circle-plus" @click="addSeaEq" />
              </span>
              <div v-for="(seaEq, index) in filter.seaEqList" v-if="type === SystemConstants.PRICE_INQUIRY_TYPE_SEA_FCL.code" :key="index">
                <div style="display: flex; align-items: center; justify-content: flex-start">
                  <el-form-item :label="$t('CargoMsg.Cargo_ContainerSize')" required>
                    <cargo-advance-select
                      style="width: 200px"
                      no="type"
                      tag-value="code"
                      filterable
                      :clearable="false"
                      :default-value="seaEq.type"
                      :static-options="SystemConstants.SEA_EQ_TYPES"
                      @parentCallBack="p=>{seaEq.type=p.value}"
                    />
                  </el-form-item>
                  <el-form-item :label="$t('CargoMsg.Cargo_AmountNumber')" required>
                    <el-input-number
                      v-model="seaEq.quantity"
                      no="quantity"
                      :clearable="false"
                      controls-position="right"
                      style="width: 140px;"
                      :precision="0"
                      :min="1"
                    />
                  </el-form-item>
                  <i style="color: #f56c6c; cursor: pointer; right: 35px; top: 5px; font-size: 18px" class="el-icon-remove" @click="deleteSeaEq(index)" />
                </div>
              </div>
            </el-form>
            <!--装箱门点/起运地区域-->
            <el-form v-if="filter.prePortEnable" :inline="true" label-position="right" class="form-item-200">
              <!--装箱门点-->
              <span class="title">{{ $t('CargoMsg.Cargo_PackingDoorPoint') }}</span>
              <div style="display: flex;">
                <cargo-area
                  no="city"
                  country="CN"
                  :province.sync="filter.province"
                  :city.sync="filter.city"
                  :district.sync="filter.districts"
                  :town.sync="filter.townUuid"
                  :show-town="true"
                  :select-width="150"
                  style="display: inline-block; margin-left: 115px"
                />
              </div>
            </el-form>
            <!--尾程送货地址信息-->
            <el-form
              v-if="filter.lastMileEnable"
              label-width="140px"
              label-position="right"
            >
              <!--尾程送货地址-->
              <span class="title">{{ $t('CargoMsg.Cargo_LastMileDeliveryAddress') }}</span>
              <!--配送地址类型-->
              <el-form-item :label="$t('CargoMsg.Cargo_DeliveryAddressType')" required>
                <el-radio-group v-model="filter.deliveryAddressType" @change="deliveryAddressTypeChange">
                  <el-radio :label="SystemConstants.DELIVERY_ADDRESS_TYPE_THIRD_PARTY.code" style="margin-right: 5px;">{{ $t('CargoMsg.Cargo_ThirdPartyAddress') }}</el-radio>
                  <el-radio :label="SystemConstants.DELIVERY_ADDRESS_TYPE_AMAZON_WAREHOUSE.code" style="margin-right: 5px;">{{ $t('CargoMsg.Cargo_AmazonWarehouse') }}</el-radio>
                  <el-radio :label="SystemConstants.DELIVERY_ADDRESS_TYPE_ECANG.code" style="margin-right: 5px;">{{ $t('CargoMsg.Cargo_YiCang') }}</el-radio>
                  <el-radio :label="SystemConstants.DELIVERY_ADDRESS_TYPE_WALMART_WAREHOUSE.code" style="margin-right: 5px;">{{ $t('CargoMsg.Cargo_WalmartWarehouse') }}</el-radio>
                </el-radio-group>
              </el-form-item>
              <!--邮编-->
              <el-form-item
                v-if="filter.deliveryAddressType === SystemConstants.DELIVERY_ADDRESS_TYPE_THIRD_PARTY.code"
                :label="$t('SeaExport.ZIP')"
                required
              >
                <cargo-post-code-select
                  :default-value="filter.postalCode"
                  @change="postCodeChange"
                />
              </el-form-item>
              <!--地址 由邮编中的城市，可编辑 -->
              <el-form-item
                v-if="filter.deliveryAddressType === SystemConstants.DELIVERY_ADDRESS_TYPE_THIRD_PARTY.code"
                :label="$t('SeaExport.Addr')"
              >
                <el-input v-model="filter.address" />
              </el-form-item>
              <!--仓库代码-->
              <el-form-item
                v-if="filter.deliveryAddressType === SystemConstants.DELIVERY_ADDRESS_TYPE_AMAZON_WAREHOUSE.code ||
                  filter.deliveryAddressType === SystemConstants.DELIVERY_ADDRESS_TYPE_ECANG.code ||
                  filter.deliveryAddressType === SystemConstants.DELIVERY_ADDRESS_TYPE_WALMART_WAREHOUSE.code"
                :label="$t('CargoMsg.Cargo_WarehouseCode2')"
                required
              >
                <cargo-advance-select
                  no="overseaWarehouseCode"
                  :select-type="TYPE_NAMES.basic_data_OverseaWarehouse"
                  filterable
                  :method-params="{ifFba:true}"
                  :clearable="false"
                  tag-name="warehouseCode"
                  tag-value="warehouseCode"
                  :default-value="filter.warehouseCode"
                  style="width:100%;"
                  @parentCallBack="p=>{filter.warehouseCode=p.value}"
                />
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </div>

    <!-- AI识别弹窗 -->
    <cargo-ai-recognition-dialog
      :visible.sync="aiRecognitionDialog.visible"
      :multimodal="aiRecognitionDialog.multimodal"
      :prompt-key="aiRecognitionDialog.promptKey"
      :call-back="aiRecognitionDialog.callBack"
      :title="$t('CargoMsg.CargoMsg_AIAddressRecognition')"
      :placeholder="aiRecognitionDialog.placeholder"
    />
  </div>
</template>

<script>

import CargoAiRecognitionDialog from '@/views/cargo/v0/SeaExport/components/booking/ams/cargoAiRecognitionDialog.vue'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import cargoArea from '@/components/Cargo/Common/cargoArea'
import cargoPostCodeSelect from '@/components/Cargo/Common/cargoPostCodeSelect'

export default {
  name: 'PriceCombinationStep1', // 询价-详情-匹配运价/报价、运价查询-整箱-组合查询
  components: { CargoAiRecognitionDialog, CargoAdvanceSelect, cargoArea, cargoPostCodeSelect },
  props: {
    type: { type: Number, default: SystemConstants.PRICE_INQUIRY_TYPE_SEA_FCL.code }, // 运价/询价类型 1-海运整箱、 2-海运拼箱、 3-空运
    filter: { type: Object, default: () => { return {} } } // 运价/询价类型 1-海运整箱、 2-海运拼箱、 3-空运
  },
  data() {
    return {
      aiRecognitionDialog: {
        multimodal: false, // 多模态模式，true-多模态支持上传文件;false-仅文本上传
        callBack: null,
        promptKey: SystemConstants.REGION_PROMPT_KEY.code,
        visible: false
      },
      SystemConstants, TYPE_NAMES
    }
  },
  methods: {
    podChange(p) {
      this.filter.pod = p.value
      if ([SystemConstants.PRICE_INQUIRY_TYPE_SEA_FCL.code, SystemConstants.PRICE_INQUIRY_TYPE_SEA_LCL.code].indexOf(this.type) > -1) {
        this.filter.commerceCode = JobUtils.getLineByPort(this.filter.pod, SystemConstants.PORT_TYPE_SEAPORT.code)
      } else if (SystemConstants.PRICE_INQUIRY_TYPE_AIR.code === this.type) {
        this.filter.commerceCode = JobUtils.getLineByPort(this.filter.pod, SystemConstants.PORT_TYPE_AIRPORT.code)
      }
    },

    addSeaEq() {
      if (this.filter.seaEqList.length === 5) {
        return
      }
      this.filter.seaEqList.push({
        type: null,
        quantity: 1
      })
    },

    deleteSeaEq(index) {
      if (this.filter.seaEqList.length === 1) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseMaintainAtLeastOne') + this.$t('CargoMsg.Cargo_CartonQuantity'))
        return
      }
      this.filter.seaEqList.splice(index, 1)
    },
    postCodeChange(post) {
      if (post) {
        this.filter.postalCode = post.uuid
        this.filter.address = post.city
      } else {
        this.filter.postalCode = ''
        this.filter.address = ''
      }
    },
    deliveryAddressTypeChange() {
      this.filter.postalCode = ''
      this.filter.address = ''
      this.filter.warehouseCode = ''
    }
  }
}
</script>

<style scoped lang="scss">
.form-column {
  width: 980px !important;
}
</style>
